<template>
  <span class="char-count-wrap">
    <span class="char-count">
      <span class="valid" v-if="remaining === 0">
        <v-icon small>check_circle</v-icon>
      </span>
      <span v-if="remaining !== 0">more {{ remaining }} chars required</span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    text: String,
    min: Number,
    max: Number,
  },
  computed: {
    length() {
      const text = this.text || '';
      return text.length;
    },
    remaining() {
      const remaining = this.min - this.length;
      return Math.max(remaining, 0);
    },
    excess() {
      const excess = this.length - this.max;
      return Math.min(excess, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.char-count-wrap {
  font-weight: lighter;
  font-size: 12px;
  color: $light;
  width: 100%;
}

.char-count {
  float: right;
}

.char-count .valid, .char-count .valid i {
  color: $completed;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/CharacterCount.vue